import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ElanAdmin.css';
import moment from 'moment';
import 'moment/locale/az';
import ElanController from '../../../api/elan/ElanController';
import UserController from '../../../api/user/UserController';
import LotoreyaController from '../../../api/lotoreya/LotoreyaController';
import BoostModal from '../../../components/BoostModal';

const ElanAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [elan, setElan] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [contact, setContact] = useState(null);
  const [showBoostModal, setShowBoostModal] = useState(false);
  const [lotoreyaStatus, setLotoreyaStatus] = useState(null);


  useEffect(() => {
    const loadElan = async () => {
      try {
        const response = await ElanController.getElanById(id);
        setElan(response);

        if (response.userId) {
          const userResponse = await UserController.getUserById(response.userId);
          setContact(userResponse);
        }
      } catch (error) {
        console.error('Elan yüklənərkən xəta:', error);
      } finally {
        setIsLoading(false);
      }
    };
    loadElan();
  }, [id]);

  const handleBoostAd = () => {
    setShowBoostModal(true);
  };

  const handleSelectBoost = async (option) => {
    try {
      setShowBoostModal(false);

      // Əgər artıq premium elan varsa və bitmə tarixi mövcuddursa, həmin tarixdən başla
      let baseDate = elan.premium && elan.expireDate
        ? moment(elan.expireDate)
        : moment(); // əks halda indiki tarixdən başla

      const newExpire = baseDate.clone().add(option.days, 'days');

      // Elanı serverdə yenilə
      await ElanController.updateElan(elan.id, {
        premium: true,
        expireDate: newExpire.toISOString(),
      });

      // Elan state-ni yerində yenilə
      setElan(prev => ({
        ...prev,
        premium: true,
        expireDate: newExpire.toISOString(),
      }));

      alert(`${option.days} gün əlavə edildi!\nPremium Elanın Bitmə tarixi: ${newExpire.locale('az').format('LL, HH:mm')}`);

      // WhatsApp yönləndirmə — saxlanılır
      if (contact && contact.phoneNumber) {
        let cleanedNumber = contact.phoneNumber.replace(/\D/g, '');

        if (cleanedNumber.startsWith('0')) {
          cleanedNumber = '994' + cleanedNumber.substring(1);
        } else if (!cleanedNumber.startsWith('994')) {
          cleanedNumber = '994' + cleanedNumber;
        }

        const message = `Salam. Sizin elan ${option.days} gün artırıldı.\nPremium Elanın Bitmə tarixi - ${newExpire.locale('az').format('LL, HH:mm')}\nElan linki - https://mototaksi.az/elan/${elan.id}`;
        const whatsappLink = `https://wa.me/${cleanedNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappLink, '_blank');
      } else {
        alert('İstifadəçinin telefon nömrəsi tapılmadı.');
      }

    } catch (error) {
      console.error('Boost zamanı xəta:', error);
      alert('Elanı boost etmək alınmadı.');
    }
  };

  useEffect(() => {
    const checkLotoreyaStatus = async () => {
      try {
        const allLotoreyas = await LotoreyaController.getAllLotoreyas();
        const lotoreya = allLotoreyas.find(l => l.elanId === elan.id);

        if (lotoreya) {
          setLotoreyaStatus(lotoreya.isAccept ? 'accepted' : 'pending');
        } else {
          setLotoreyaStatus(null);
        }
      } catch (error) {
        console.error('Lotoreya statusu yoxlanarkən xəta:', error);
      }
    };

    if (elan) {
      checkLotoreyaStatus();
    }
  }, [elan]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleUsernameClick = (userId) => {
    navigate(`/private/istifadeciler/${userId}`);
  };

  const handleDelete = async () => {
    const confirmed = window.confirm("Bu elanı silmək istədiyinizə əminsiniz?");
    if (confirmed) {
      try {
        await ElanController.deleteElanById(id);
        alert("Elan silindi.");
        navigate("/profile"); // Yönləndirmə profilə və ya ana səhifəyə
      } catch (error) {
        console.error("Elan silinərkən xəta:", error);
        alert("Elanı silmək mümkün olmadı.");
      }
    }
  };

  const handleEdit = () => {
    navigate(`/private/edit-elan/${id}`);
  };

  if (isLoading) {
    return <div>Yüklənir...</div>;
  }

  const handleUnboostAd = async () => {
    try {
      const confirmed = window.confirm("Bu elanı geri çəkmək istədiyinizə əminsiniz?");
      if (!confirmed) return;

      await ElanController.updateElan(elan.id, {
        premium: false,
        expireDate: null,
      });

      alert("Elan geri çəkildi!");

      // Yerlərdəki elan state-ni yenilə (gözləntisiz update üçün):
      setElan(prev => ({
        ...prev,
        premium: false,
        expireDate: null,
      }));

    } catch (error) {
      console.error('Elanı geri çəkərkən xəta:', error);
      alert('Elanı geri çəkmək mümkün olmadı.');
    }
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';

    let cleanedNumber = phone.replace(/\D/g, ''); // Rəqəmlərdən başqa hər şeyi sil

    if (cleanedNumber.startsWith('0')) {
      cleanedNumber = '994' + cleanedNumber.substring(1); // 0-ı at, 994 əlavə et
    } else if (cleanedNumber.startsWith('994')) {
      // artıq düz formatdadır
    } else if (cleanedNumber.startsWith('4') || cleanedNumber.length === 9) {
      // ola bilər ki, lokal nömrə verilib (050123456 gibi)
      cleanedNumber = '994' + cleanedNumber;
    } else if (cleanedNumber.startsWith('')) {
      cleanedNumber = '994' + cleanedNumber;
    }

    return cleanedNumber;
  };

  return (
    <div className="elan-container">
      <button className="back-button" onClick={handleBack}>Geri</button>

      <div className="elan-header">

        <div style={{ position: 'relative' }}>
          <img src={elan.image} alt={elan.title} className="elan-image" />

          {lotoreyaStatus === 'pending' && (
            <div className="lotoreya-badge-on-image">Lotoreya Sorğusu göndərilib</div>
          )}
          {lotoreyaStatus === 'accepted' && (
            <div className="lotoreya-badge-on-image">Lotoreyada</div>
          )}
        </div>

        <div className="elan-info">
          <h2 className="elan-title">{elan.title}</h2>
          <p className="elan-price">{elan.price} ₼</p>
          <div className="elan-meta">
            <span>{moment(elan.createdAt).locale('az').format('LL, HH:mm')}</span>
          </div>

          <div className="elan-body">{elan.description}</div>

          <div className="elan-footer">
            <div className="contact-info">
              <div className="contact-person">
                <span><strong>Əlaqə:</strong></span>
                <span
                  className="clickable-username"
                  onClick={() => handleUsernameClick(contact.id)}
                >
                  {contact ? contact.name : 'Yüklənir...'}
                </span>
                <span>{contact ? contact.phoneNumber : 'Yüklənir...'}</span>
              </div>
            </div>
          </div>

          {showBoostModal && (
            <BoostModal
              onClose={() => setShowBoostModal(false)}
              onSelect={handleSelectBoost}
            />
          )}

          {elan.premium && (
            <div className="premium-info">
              <span className="premium-badge-box">PREMIUM ELAN</span>
              {elan.expireDate && (
                <span className="premium-expire">
                  Premium Elanın Bitmə tarixi: {moment(elan.expireDate).locale('az').format('LL, HH:mm')}
                </span>
              )}
            </div>
          )}

          <div className="elan-actions">
            <button className="boost-btn" onClick={handleBoostAd}>Elanı irəli çək</button>

            {elan.premium && (
              <button className="unboost-btn" onClick={handleUnboostAd}>Elanı geri çək</button>
            )}

            {contact && contact.phoneNumber && (
              <>
                <a className="call-btn" href={`tel:${contact.phoneNumber}`}>Zəng et</a>
                <a
                  className="whatsapp-btn"
                  href={`https://wa.me/${formatPhoneNumber(contact.phoneNumber)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Whatsapp ilə əlaqə
                </a>
              </>
            )}

            <div className="owner-actions">
              <button className="edit-btn" onClick={handleEdit}>Düzəliş et</button>
              <button className="delete-btn" onClick={handleDelete}>Sil</button>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export default ElanAdmin;

